module.exports = __webpack_public_path__ + "img/logo.e3041d78.svg";